
import React from 'react';
import { Link } from 'react-router-dom';


class Categories extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { containerClass, categories } = this.props;

    return (
      <ul className={containerClass}>
        { Object.keys(categories).
          sort((a, b) => categories[a].localeCompare(categories[b])).
          map((category) => (
            <li key={category}>
              <Link key={category} to={`/news/category/${category}`} onClick={this.props.categoryClick}>{categories[category]}</Link>
            </li>
          ))
        }
      </ul>
    );
  }
}

export default Categories;
